<style src="./PanelTabItem.scss" lang="scss" scoped></style>
<template>
  <li
    class="panel-tab-item"
    :class="{'panel-active': activeClass}"
    @click="chooseThis">
    <slot />
  </li>
</template>

<script>
export default {
  name: 'PanelTabItem',
  props: {
    tabId: {
      default: null
    },
    panelChoose: {
      default: null
    }
  },
  computed: {
    activeClass () {
      return this.tabId === this.panelChoose
    }
  },
  methods: {
    chooseThis () {
      this.$parent.$emit('choose-item', this.tabId)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/panel-tab/panel-tab-item/PanelTabItem.vue